import _ from "lodash";

export default function FormatBytes(bytes, decimals = 3) {
  if (bytes === 0) return "0 Bytes";

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
}

export const getAbsoluteOffsetTop = (element) => {
  let offset = 0;

  while (element) {
    offset += element.offsetTop;
    element = element.parentElement;
  }

  return offset;
};

export const b64toBlob = (b64Data, contentType = "", sliceSize = 512) => {
  const byteCharacters = atob(b64Data);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize);

    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }

  const blob = new Blob(byteArrays, { type: contentType });
  return blob;
};

export const dateDifferance = (startDate, endDate) => {
  if (new Date(endDate).getTime() < 0) {
    return;
  }
  let number = (new Date(endDate).getTime() - new Date(startDate).getTime()) / 1000;
  let seconde = 1;
  let minute = seconde * 60;
  let houre = minute * 60;
  let day = houre * 24;
  let week = day * 7;
  let mounth = week * 4.34524;
  let year = mounth * 12;
  if (number <= seconde) {
    return number.toFixed(2) + " ms";
  } else if (number > seconde && number <= minute) {
    return number + " sec";
  } else if (number > minute && number <= houre) {
    return (number / minute).toFixed(2) + " min";
  } else if (number > houre && number <= day) {
    return (number / houre).toFixed(2) + " Hour";
  } else if (number > day && number <= week) {
    return (number / day).toFixed(2) + " Day";
  } else if (number > week && number <= mounth) {
    return (number / week).toFixed(2) + " Week";
  } else if (number > mounth && number <= year) {
    return (number / mounth).toFixed(2) + " Mounth";
  } else if (number > year) {
    return (number / year).toFixed(2) + " Year";
  }
};

export const isValidUrl = (str) => {
  const pattern = new RegExp(
    "^(https?:\\/\\/)?" + // protocol
      "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // domain name
      "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR ip (v4) address
      "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // port and path
      "(\\?[;&a-z\\d%_.~+=-]*)?" + // query string
      "(\\#[-a-z\\d_]*)?$",
    "i"
  ); // fragment locator
  return !!pattern.test(str);
};

/**
 * compose functions
 */
export const compose = (...fns) =>
  fns.reduceRight(
    (prevFn, nextFn) => (...args) => nextFn(prevFn(...args)),
    (value) => value
  );

/**
 * debounce function: execute func on
 * every delay
 */
export const debounce = (func, delay) => {
  let timeoutFn;
  return function () {
    const context = this;
    const args = arguments;
    clearTimeout(timeoutFn);
    timeoutFn = setTimeout(() => func.apply(context, args), delay);
  };
};

export const formatDuration = (duration) => {
  if (duration === 0) return "0 Hrs";
  const sizes = ["Hrs", "K Hrs", "M Hrs", "B Hrs"];
  let rest = 1;
  let seconds = (duration / 1000).toFixed(1);
  let minutes = (duration / (1000 * 60)).toFixed(1);
  let hours = (duration / (1000 * 60 * 60)).toFixed(1);
  if (seconds < 60) return seconds + " Sec";
  else if (minutes < 60) return minutes + " Mins";
  for (let i = 0; i < sizes.length; i++) {
    const total = hours / rest;
    if (total < 1000) {
      return total.toFixed(1) + " " + sizes[i];
    }
    rest *= 1000;
  }
};

export const removeNils = (obj) => _.omitBy(obj, _.isNil);

export const copyTextToClipboard = async (text) => {
  if (!navigator.clipboard) {
    return;
  }
  try {
    await navigator.clipboard.writeText(text);
  } catch (error) {
    console.error(error);
  }
};

export const periodFormatter = (value) => {
  const days = Math.floor(value / (60 * 24));
  const hours = Math.floor((value - days * 60 * 24) / 60);
  const minutes = Math.floor(value - days * 60 * 24 - hours * 60);
  return `${days}D ${hours}H ${minutes}m`;
};

export const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

export const randomString = (length) => {
  let text = "";
  const possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  for (let i = 0; i < length; i++) {
    text += possible.charAt(Math.floor(Math.random() * possible.length));
  }
  return text;
};

export const convertToTitleCase = (inputString) => {
  const words = inputString.split(/(?=[A-Z])/);
  const titleCaseWords = words.map((word) => word.toLowerCase().charAt(0).toUpperCase() + word.slice(1));
  const titleCaseString = titleCaseWords.join(" ");
  return titleCaseString;
};
